import React from "react";
import bannerimg from "../../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-27.jpg";
import bannerimg_m from "../../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-27.jpg";
const ServiceBanner = () => {
  return (
    <div className=" w-full xl:bg-fixed relative mx-auto  overflow-hidden flex items-center justify-center">
      {/* Content */}
      <div className="w-full">
        <img src={bannerimg} alt="" className="w-full  h-auto hidden xl:block " />
        <img src={bannerimg_m} alt="" className="w-full  h-auto  block xl:hidden " />
      </div>
    </div>
  );
};
export default ServiceBanner;
